import videojs from 'video.js';
import type Component from 'video.js/dist/types/component';
import { getTranslations } from '~/services/localization/index.ts';

const PLAYER_ERROR_TITLE_KEY = 'player_error_title';
const DEFAULT_PLAYER_ERROR_TITLE = 'Cannot Play Video';

let localizationsRef: Record<string, Record<string, string>> | undefined;

/**
 * Builds an Element for the error modal with a title and description.
 * Returns an Element (assignable to VideoJS's ContentDescriptor).
 */
function buildErrorContent({
  title,
  description,
}: {
  title: string;
  description: string;
}): HTMLElement {
  const container = document.createElement('div');
  container.className = 'vjs-error-content';

  const titleEl = document.createElement('p');
  titleEl.className = 'vjs-error-title';
  titleEl.textContent = title;

  const descriptionEl = document.createElement('p');
  descriptionEl.className = 'vjs-error-description';
  descriptionEl.textContent = description;

  container.appendChild(titleEl);
  container.appendChild(descriptionEl);

  return container;
}

let isRegistered = false;

function registerOnce(): void {
  if (isRegistered) return;
  isRegistered = true;

  const OriginalErrorDisplay = videojs.getComponent(
    'ErrorDisplay'
  ) as unknown as typeof Component;

  class CustomErrorDisplay extends OriginalErrorDisplay {
    content(): Element | string {
      const error = (this as any).player().error();

      if (!error) return '';

      const translations = getTranslations(localizationsRef);
      const title =
        translations?.[PLAYER_ERROR_TITLE_KEY] ?? DEFAULT_PLAYER_ERROR_TITLE;
      const description = error.message ?? '';

      return buildErrorContent({ title, description });
    }
  }

  videojs.registerComponent(
    'ErrorDisplay',
    CustomErrorDisplay as unknown as typeof Component
  );
}

export function updateErrorDisplayLocalizations(
  localizations: Record<string, Record<string, string>> | undefined
): void {
  registerOnce();
  localizationsRef = localizations;
}
